import { object, string } from 'yup';
import * as yup from 'yup';

export const schema = object().shape({
  name: string().required(),
  countryId: string().required(),
});

export const emailSchema = yup.string().email();
